import {Component, OnDestroy, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {TelaExpandidaComponent} from "../TelaExpandida";
import {ConstantsService, ModulosEnum} from "../../fidelidade/ConstantsService";
import {NotificationService} from "@progress/kendo-angular-notification";
import {EmpresaService} from "../../services/empresa.service";
import {PedidosService} from "../../services/pedidos.service";
import {Router} from "@angular/router";
import {AutorizacaoService} from '../../services/autorizacao.service';
import {RotaGuardClient} from '../../guards/auth-loja.guard';


@Component({
  selector: 'app-tela-pedidos',
  templateUrl: './tela-pedidos.component.html',
  styleUrls: ['./tela-pedidos.component.scss']
})
export class TelaPedidosComponent extends TelaExpandidaComponent implements OnInit, OnDestroy {
  empresa: any = {};
  moduloFiadoAtivo = false;
  codigoLocalizar = '';
  localizandoPedido = false;
  mensagemLocalizador = '';
  exibirLocalizadorPedido = false;
  exibirPrazoEntrega = false;
  salvandoPrazoEntrega = false;
  erroPrazoEntrega = '';
  mensagemPrazoEntrega = '';
  prazoEntrega = {tempoMinimo: null as number, tempoMaximo: null as number, unidadeTempo: 'MINUTOS'};
  private destruir$ = new Subject<void>();
  @ViewChild('appendTo', { read: ViewContainerRef }) public appendTo: ViewContainerRef;
  constructor(private  constantsService: ConstantsService,  private notificationService: NotificationService,
              private empresasService: EmpresaService, private pedidosService: PedidosService,
              private router: Router, private autorizacaoService: AutorizacaoService) {
    super();
  }

  ngOnInit() {
    this.constantsService.empresa$.pipe(takeUntil(this.destruir$)).subscribe( (empresa) => {
      if(this.empresa.id !== empresa?.id) {
        this.exibirPrazoEntrega = false;
        this.mensagemPrazoEntrega = '';
        this.erroPrazoEntrega = '';
      }

      this.empresa = empresa || {};
      this.moduloFiadoAtivo = this.constantsService.possuiModulo(empresa, ModulosEnum.FIADO);
    });
  }

  ngOnDestroy() {
    this.destruir$.next();
    this.destruir$.complete();
  }

  get formaEntrega(): any {
    return this.empresa.formasDeEntrega?.find((forma: any) => forma.formaDeEntrega?.id === 2 && forma.ativa);
  }

  get podeAlterarPrazoEntrega(): boolean {
    return RotaGuardClient.gerenciaLoja(this.autorizacaoService.getUser());
  }

  get descricaoPrazoEntrega(): string {
    const forma = this.formaEntrega;
    if(!forma?.tempoMinimo || !forma?.tempoMaximo) return 'Não informado';
    const unidade = forma.unidadeTempo === 'HORAS' ? 'h' : (forma.unidadeTempo === 'DIAS' ? 'dias' : 'min');
    return `${forma.tempoMinimo}–${forma.tempoMaximo} ${unidade}`;
  }

  abraPrazoEntrega() {
    if(!this.formaEntrega || !this.podeAlterarPrazoEntrega || this.salvandoPrazoEntrega) return;
    const {tempoMinimo, tempoMaximo, unidadeTempo} = this.formaEntrega;
    this.prazoEntrega = {tempoMinimo, tempoMaximo, unidadeTempo: unidadeTempo || 'MINUTOS'};
    this.erroPrazoEntrega = '';
    this.mensagemPrazoEntrega = '';
    this.exibirLocalizadorPedido = false;
    this.exibirPrazoEntrega = true;
  }

  fechePrazoEntrega() {
    if(this.salvandoPrazoEntrega) return;
    this.exibirPrazoEntrega = false;
    this.erroPrazoEntrega = '';
  }

  async salvePrazoEntrega() {
    if(this.salvandoPrazoEntrega || !this.exibirPrazoEntrega || !this.podeAlterarPrazoEntrega) return;
    const {tempoMinimo, tempoMaximo, unidadeTempo} = this.prazoEntrega;
    this.erroPrazoEntrega = '';
    if(!Number.isInteger(tempoMinimo) || !Number.isInteger(tempoMaximo) || tempoMinimo <= 0 || tempoMaximo <= 0) {
      this.erroPrazoEntrega = 'Informe os tempos mínimo e máximo em números inteiros maiores que zero.';
      return;
    }
    if(tempoMaximo < tempoMinimo) {
      this.erroPrazoEntrega = 'O tempo máximo não pode ser menor que o mínimo.';
      return;
    }

    const idEmpresa = this.empresa.id;
    this.salvandoPrazoEntrega = true;
    try {
      const prazo = await this.empresasService.atualizePrazoEntrega(idEmpresa, {tempoMinimo, tempoMaximo, unidadeTempo});
      if(this.empresa.id !== idEmpresa) return;
      if(this.formaEntrega) Object.assign(this.formaEntrega, prazo);
      this.exibirPrazoEntrega = false;
      this.mensagemPrazoEntrega = 'Prazo de entrega atualizado.';
    } catch (erro) {
      if(this.empresa.id === idEmpresa)
        this.erroPrazoEntrega = erro?.message || erro || 'Não foi possível salvar o prazo de entrega.';
    } finally {
      this.salvandoPrazoEntrega = false;
    }
  }

  alterouAceitarAutomatico(aceitarPedidoAutomatico ) {

   this.empresasService.altereAceitarPedido(aceitarPedidoAutomatico).then( (resp) => {
      this.notificationService.show({
        content: aceitarPedidoAutomatico ? 'Alterado para aceitar pedidos automaticamente!' : "Alterado para não aceitar pedidos automaticamente",
        appendTo: this.appendTo,
        hideAfter: 2000,
        position: { horizontal: "center", vertical: "top" },
        animation: { type: "fade", duration: 800 },
        type: { style: "success", icon: true },
      });
    }).catch((err) => {
     setTimeout(() => {
       this.empresa.aceitarPedidoAutomatico = !aceitarPedidoAutomatico
     }, 500)
     alert(err)
   })
  }

  altereExibicaoLocalizadorPedido() {
    this.fechePrazoEntrega();
    this.exibirLocalizadorPedido = !this.exibirLocalizadorPedido;
    this.mensagemLocalizador = '';
  }

  fecheLocalizadorPedido() {
    this.exibirLocalizadorPedido = false;
    this.mensagemLocalizador = '';
  }

  localizePedidoPorCodigo() {
    if(this.localizandoPedido) return;

    const codigo = String(this.codigoLocalizar || '').trim();

    this.mensagemLocalizador = '';

    if(!/^\d{1,9}$/.test(codigo)) {
      this.mensagemLocalizador = 'Digite um código de pedido válido.';
      return;
    }

    this.localizandoPedido = true;

    this.pedidosService.localizePedidoPorCodigo(codigo).then((pedidos: any[]) => {
      this.localizandoPedido = false;

      if(!pedidos || !pedidos.length) {
        this.mensagemLocalizador = `Nenhum pedido com o código ${codigo} nesta loja.`;
        return;
      }

      this.exibirLocalizadorPedido = false;
      this.router.navigate(['/admin/pedidos/detalhes', pedidos[0].guid]);
    }).catch((erro) => {
      this.localizandoPedido = false;
      this.mensagemLocalizador = erro || 'Não foi possível localizar o pedido.';
    });
  }
}
